import { InfoTooltip } from "./InfoTooltip";
import { SingleRecipient } from "../../forms/SelectRecipientsForm/SingleRecipientValidationSchema";
import clsx from "clsx";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

type RecipientColumnProps = {
  recipient: SingleRecipient;
  colKey: keyof SingleRecipient;
};

export const RecipientCell = ({ recipient, colKey }: RecipientColumnProps) => {
  const { t } = useTranslation();

  if (recipient.hasOwnProperty("isGranted") && !recipient.isGranted) {
    return (
      <div className="relative p-6">
        {/* Added `&nbsp;` for the styles to not collapse when the text is empty */}
        <span className="flex">{recipient[colKey]}&nbsp;</span>
        <div
          className={clsx(
            "mt-1",
            "text-xs",
            "absolute",
            "right-0.5",
            "bottom-0.5",
            "flex",
            "flex-row",
            "items-center",
            "w-full",
            "pl-6",
            "gap-1"
          )}
        >
          <InfoTooltip
            content={t("sites.letters.recipients.unavailable_for_letter_sending")}
            tooltipContent={t("sites.letters.recipients.owner_details_unavailable")}
            dataTestId="unavailable-for-letter-sending"
            justifyContent="between"
            icon="icon-lt-alert-line"
            iconColor="text-amber-700"
          />
        </div>
      </div>
    );
  } else {
    return recipient[colKey];
  }
};
